export default __webpack_public_path__ + "static/me-09184f38678e842973bf5a1ba16cde2b.svg";